<template>
    <div :class="['wrap', { 'selectable': showCheckbox }]">
        <div class="top" :style="{backgroundImage: `url(${background})`}" >
            <router-link :class="['cover', {'no-click': showCheckbox}]"
                :to="{
                    path: '/user/play/',
                    query: {
                        eventId: event.id,
                        date: date,
                        cid: sampleGalleryItem.encrypt?.keyId === '0' ? undefined : cmkInfo.cid,
                        [libraryNavigationQuery]: navigationContextId
                    }
                }"
                target="_blank"
                rel="opener">
                <i class="icon-icon_play-video"></i>
            </router-link>
            <div class="tip-cover" v-if="tip">
                <div class="tip-handle">{{ tip }}</div>
            </div>
            <div :class="['cover', 'video-handler-cover', {'no-click': !showCheckbox}]">
                <div class="video-handler">
                    <span v-if="canDownLoad" class="icon-icon_download" @click="downloadVideo()"></span>
                    <span class="icon-bin-line" @click="deleting = true"></span>
                </div>
            </div>
            <div v-if="motionList.length > 0" class='motions'>
                <MotionImg v-for="(motion,index) in motionList" :src="motion" :key="motion?motion: index"/>
            </div>
        </div>
        <checkbox class="video-checkbox"
            type="fill"
            :value="event.checked"
            v-show="showCheckbox"
            @input="selectHandle"
        />
        <div class="bottom">
            <div class="info">
                <p class="title" :title="eventTypeText">{{ eventTypeText }}</p>
                <p class="details pc-details">{{ time }} / {{ deviceName }}</p>
                <div class="mobile-details">
                    <p>{{ deviceName }}</p>
                    <p>{{ time }}</p>
                </div>
            </div>
        </div>
        <template v-if="event.abstract !== ''">
            <Tip customIcon class="abstract-tip">
                <template #icon>
                    <div class="abstract">
                        {{ event.abstract }}
                    </div>

                </template>
                {{ event.abstract }}
            </Tip>
        </template>
        <reo-dialog
            v-if="deleting"
            :title="$tc( 'dialog.del' )"
            :labelOfConfirm="$t( 'dialog.yes' )"
            :labelOfCancel="$t( 'dialog.no' )"
            :switchButton="true"
            @confirm="deleteEvent(true)"
            @cancel="deleting = false"
        ></reo-dialog>
        <span v-if="expiration < 3" class="remaining-time">
            <i class="icon-icon_clock"></i>
            <span v-if="expiration === 0">&lt; 1d</span>
            <span v-else-if="expiration < 0">0d</span>
            <span v-else>{{ expiration }}d</span>
        </span>
    </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import Checkbox from '@/basic/Checkbox.vue';
import { formatTime, timeResolve } from '@/common/js/date';
import ReoDialog from '@/basic/Dialog.vue';
import defaultCover from 'IMAGE/cloud/default-cover.jpg';
import initBg from '@/common/js/defaultBg';
import { getAlarmTypeImage } from '@/common/js/getMotionImage';
import { unfoldError, unfoldSuc } from '@/common/js/notice';
import { CMKManager } from '@/utils/cmk';
import { IEventWithExtraInfo } from '../lib';
import { IAlarmType, IGallery } from '@reolink-cloud/interface';
import { deleteEvents } from '@/api/event';
import Tip from '@/basic/Tip.vue';
import { generateDownloadMapFromEvents, getEventInfo } from '@/utils/business';
import { MultiFileDownloader } from '@/utils/download';
import MotionImg from '@/components/MotionImg.vue';
import { Optimization } from '@reolink-web/utils';
import { getAlarmTypeDisplay, IAlarmTypeDisplay } from '../lib/alarmTypeSelector';
import { LIBRARY_NAVIGATION_QUERY } from '../../videos/libraryEventNavigation';

export default Vue.extend({

    components: {

        Checkbox,
        ReoDialog,
        Tip,
        MotionImg

    },

    inject: ['getCmkInfo'],

    async created () {

        initBg( this, this.event.coverUrl );

        const execGetEncryptedCover = this.cmkInfo.task;
        if ( execGetEncryptedCover ) {

            try {

                await execGetEncryptedCover;

            } catch ( e ) {

                if ( e instanceof CMKManager.Error.CMKError ) {

                    const cmkErrorData = e.data;
                    switch ( cmkErrorData.code ) {

                        case CMKManager.Error.Code.LoaderExecErr:{

                            let breakFlag = true;
                            if (( cmkErrorData as any ).loader === 'extract' ) {

                                /** @type {import('axios').AxiosError} */
                                const axiosError = ( cmkErrorData as any ).error;

                                if ( axiosError?.response?.data?.error?.symbol === 'cmk_pin_verification_failed' ) {

                                    breakFlag = false;

                                }

                            }
                            if ( breakFlag ) {

                                break;

                            }

                        }
                        // eslint-disable-next-line no-fallthrough
                        case CMKManager.Error.Code.PinNotCorrect:
                            console.log( 'pin is not correct' );
                            break;
                        default:
                            console.error( e );

                    }

                } else {

                    // fetchStream

                    console.error( e );

                }

            }

        }

    },

    data () {

        const event = this.event;

        const cmkInfo = ( this as unknown as { getCmkInfo: ( id: string ) => any; }).getCmkInfo( event.id );

        return {

            deleting: false,
            background: event.coverUrl,
            defaultBg: defaultCover,
            motionPNG: {
                'other': getAlarmTypeImage( 'other-index' ),
                'car': getAlarmTypeImage( 'car-index' ),
                'person': getAlarmTypeImage( 'person-index' ),
                'pet': getAlarmTypeImage( 'pet-index' ),
                'md': getAlarmTypeImage( 'md-index' ),
                'animal': getAlarmTypeImage( 'animal-index' ),
                'visitor': getAlarmTypeImage( 'visitor-index' )
            },
            hasCmkInfo: Boolean( cmkInfo ),
            cmkInfo: cmkInfo ?? Object.freeze({}),
            libraryNavigationQuery: LIBRARY_NAVIGATION_QUERY

        };

    },
    mounted() {

        this.downloadVideo = Optimization.debounce( this.downloadVideo, 50 );

    },

    destroyed () {

        if ( this.background.startsWith( 'blob:' )) {

            URL.revokeObjectURL( this.background );

        }

    },

    props: {

        event: Object as PropType<IEventWithExtraInfo>,
        showCheckbox: {

            type: Boolean,
            default () {

                return false;

            }

        },
        deviceObj: {

            type: Object,
            default () {

                return {};

            }
        },
        index: Number,
        date: String,
        alarmTypes: Array as PropType<IAlarmType[]>,
        navigationContextId: String

    },

    methods: {

        selectHandle ( checked ) {

            this.$emit( 'selectHandle', {

                index: this.index,
                checked

            });

        },

        async downloadVideo () {

            try {

                const downloader = new MultiFileDownloader( await this.getEventVideoUrls(), () => this.getEventVideoUrls());
                await downloader.download( formatTime( this.event.recordedAt ).replace( /\/|:/g, '-' ));

            } catch ( e ) {

                unfoldError( 'errors.download_video', 5000 );
                console.error( e );
                return;

            }

        },

        deleteEvent ( flag ) {

            if ( flag ) {

                let id = this.event.id;
                deleteEvents( [ id ] ).then(() => {

                    this.$emit( 'delete', [ id ] );
                    unfoldSuc( 'suc.delete_video', 5000 );

                }).catch( err => {

                    unfoldError( 'errors.delete_video', 5000 );
                    console.error( err );

                });

            }

            this.deleting = false;

        },
        async getEventVideoUrls() {

            const event = await getEventInfo( this.event.id );
            return generateDownloadMapFromEvents( [event] );

        }

    },

    computed: {

        time (): string {

            let timeStamp = this.event.recordedAt;
            if ( !timeStamp ) {

                return '';

            }
            let {

                hourOf12Decimal,
                minute,
                second,
                noon

            } = timeResolve( timeStamp );
            return `${hourOf12Decimal}:${minute}:${second} ${noon}`;

        },

        alarmTypeDisplay(): IAlarmTypeDisplay {

            return getAlarmTypeDisplay( this.event.alarms, this.alarmTypes );

        },

        eventTypeText(): string {

            return this.alarmTypeDisplay.text;

        },

        deviceName(): string {

            return this.deviceObj[this.event.uid] || this.event.uid;

        },

        tip (): string {

            return this.sampleGalleryItem.$helperTip;

        },

        selected (): boolean {

            return this.event.checked;

        },

        currentUrl (): string {

            return this.event.coverUrl;

        },

        expiration (): number {

            let { expiredAt } = this.event;
            let now = new Date().getTime();
            return Math.floor(( expiredAt - now ) / 86400 / 1000 );

        },

        canDownLoad (): boolean {

            return !this.hasCmkInfo || Boolean( this.cmkInfo.authKeyHeaders );

        },
        userId(): string  {

            return this.$store.getters.userId;

        },
        sampleGalleryItem(): IGallery {

            return this.event.items[0] ?? {} as IGallery;

        },
        motionList(): string[] {

            return this.alarmTypeDisplay.iconUrls;

        }
    },

    watch: {

        'event.coverUrl': {

            handler ( cover ) {

                initBg( this, cover );

            },
            deep: true

        }

    }

});
</script>

<style scoped lang="less">
    @itemRadius: 8px;

    .wrap {
        display: inline-block;
        border-radius: 8px;
        position: relative;
        background-color: @bg_02;
        min-width: 0;
    }
    .top {
        height: 158px;
        position: relative;
        border-radius: @itemRadius @itemRadius 0 0;
        z-index: 0;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
    }
    .bottom {
        background-color: #fff;
        padding: 12px 16px;
        border-radius: 0 0 @itemRadius @itemRadius;
        box-sizing: border-box;
        text-align: left;
        .mobile({
            padding: 0;
            padding-left: 10px
        });
        .info{
            .title{
                font-size: 14px;
                font-weight: 500;
                line-height: 21px;
            }
            .details{
                font-size: 12px;
                font-weight: 500;
                line-height: 18px;
                color: @font_secondary;
                margin-top: 4px;
            }
        }
    }
    .mobile-details{
        display: none;
    }
    .abstract-tip{
        margin-top: 8px;
        margin-bottom: 16px;
        width: 100%;
        border-top: 1px solid @line;
        .mobile({
            grid-column: ~'1 / -1';
            margin-bottom: 0;
        });
    }
    .abstract{
        font-size: 11px;
        font-weight: 500;
        line-height: 18px;
        padding: 0 16px;
        padding-top: 8px;
        -webkit-line-clamp: 3;
        line-clamp: 3;
        display: -webkit-box;
        overflow: hidden;
        -webkit-box-orient: vertical;
        .mobile({
            padding-left: 0;
            padding-right: 0;
        });
    }
    .no-click.cover{
        display: none !important;
    }
    .cover {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: rgb(0, 0, 0);
        border-radius: @itemRadius @itemRadius 0 0;
        z-index: 2;
        opacity: 0;
        transition: background-color 0.35s ease, opacity 0.35s ease;
        cursor: pointer;
    }
    .tip-cover {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 1;
    }
    .tip-handle {
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        position: absolute;
        color: #FFFFFF;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: Montserrat-Medium, Montserrat;
        font-weight: 500;
        line-height: 0.24rem;
        font-size: 0.20rem;
        padding: 0.25rem;

        @media @pc {
            line-height: 0.19rem;
            font-size: 0.14rem;
            padding: 0.2rem;
        }
    }
    @media screen and (min-width:1200px){
        .cover:hover {
            opacity: 1;
            background-color: rgba(0,0,0,0.3);
        }
    }
    .motions {
        position: absolute;
        padding: .08rem .12rem .1rem;
        bottom: 0;
        width: 100%;
        font-weight: 500;
        color: #fff;
        font-size: 0.14rem;
        box-sizing: border-box;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        display: flex;
        gap: 4px;
    }
    .cover>i {
        font-size: 0.25rem;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: #fff;
    }
    .time {
        font-weight: 500;
        font-size: 0.16rem;
        color: #333;
        margin-bottom: 0.02rem;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }
    .day {
        font-size: 0.14rem;
        color: #595757;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .video-checkbox{
        position: absolute;
        right: 0.1rem;
        top: 0.1rem;
        z-index: 3;
        .mobile({
            top: 12px;
            right: 12px;
        });
        /deep/ .no-checked{
            border-color: @white;
            background-color: @black2;
            .mobile({
                border-color: @b_6;
                background-color: unset;
            })
        }
    }
    .video-handler{
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 100%;
        text-align: center;
    }
    .video-handler span{
        background-color: #fff;
        border-radius: 100%;
        width: 0.44rem;
        height: 0.44rem;
        box-sizing: border-box;
        cursor: pointer;
        display: inline-block;
        position: relative;
    }
    .bottom .show-on-mobile{
        display: none;
    }
    .video-handler span:first-child ~ span{
        margin-left: 0.2rem;
    }
    .video-handler .icon-icon_download:before,
    .video-handler .icon-bin-line:before{
        font-size: 0.24rem;
        color: #333;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
    }
    .video-handler .icon-icon_download:hover:before,
    .video-handler .icon-bin-line:hover:before{
        color: @theme;
    }
    .remaining-time{
        position: absolute;
        left: 0;
        top: 0.1rem;
        color: #fff;
        font-size: 0.16rem;
        font-weight: 500;
        background-color: #D94429;
        padding: 0 0.1rem;
        line-height: 0.24rem;
        border-top-right-radius: 0.03rem;
        border-bottom-right-radius: 0.03rem;
        i{
            font-size: 0.12rem;
        }
    }
    @media @mobile{
        .remaining-time{
            font-size: 0.2rem;
            padding: 0.05rem 0.1rem;
            border-top-right-radius: 0.05rem;
            border-bottom-right-radius: 0.05rem;
            span{
                line-height: 1;
                vertical-align: top;
            }
            i{
                font-size: 0.16rem;
            }
        }
    }
    @media screen and (max-width:1199px){
        .bottom .show-on-pc{
            display: none;
        }
        .bottom .show-on-mobile{
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;
            p{
                width:100%
            }
            .uid{
                margin:.14rem  0 .10rem;
                font-size: .2rem;
            }
        }
        .bottom .show-on-mobile .time{
            flex-grow: 1;
            margin-right: 0.1rem;
            margin-bottom: 0;
        }
        .size{
            font-size: 0.26rem;
        }
        .wrap{
            width: 100%;
            padding: 12px;
            background-color: #fff;
            display: grid;
            grid-template-columns: 116px minmax(0, 1fr);
            column-gap: 10px;
            row-gap: 8px;
            box-sizing: border-box;

            &.selectable{
                grid-template-columns: 116px minmax(0, 1fr) 20px;
            }
        }
        .top{
            height: 63px;
            border-radius: 6px;
        }
        .motions{
            padding: 4px;
        }
        .bottom{
            align-self: stretch;
            background-color: transparent;
            padding: 0;

            .info{
                display: flex;
                flex-direction: column;
                gap: 4px;
                height: 100%;
                justify-content: center;
            }

            .pc-details{
                display: none;
            }

            .mobile-details{
                color: @font_secondary;
                display: flex;
                flex-direction: column;
                font-size: 12px;
                font-weight: 400;
                gap: 4px;
                line-height: 17px;
            }
        }
        .video-checkbox{
            /deep/ .reo-checkbox{
                height: 20px;
                width: 20px;
            }
            align-self: center;
            grid-column: 3;
            grid-row: 1;
            justify-self: end;
            position: static;
        }
        .abstract-tip{
            border-top: 0;
            grid-column: ~'1 / -1';
            margin: 0;
        }
        .abstract{
            font-size: 12px;
            font-weight: 400;
            line-height: 17px;
            padding: 0;
        }
        .time{
            font-size: 0.24rem;
        }
        .day{
            font-size: 0.2rem;
        }
        .video-handler-cover{
            display: none;
        }
        .cloud{
            font-size: 0.24rem;
        }
        .title{
            font-size: 14px;
            font-weight: 500;
        }
    }
</style>
